import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injector, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';

import { environment } from 'src/environments/environment';
import { AgentModule } from './agent/agent.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { loadBrandedPortalKey } from './branded-portal-key.initializer';
import { CoreModule } from './core/core.module';
import { FaqModule } from './faq/faq.module';
import { FeedbackModule } from './feedback/feedback.module';
import { GraphqlModule } from './graphql/graphql.module';
import { GlobalErrorHandler } from './shared/error-handlers/global-error-handler';
import { ServiceLocator } from './shared/service-locator.service';

@NgModule({
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		CoreModule.forRoot(),
		ToastrModule.forRoot({
			positionClass: 'toast-top-center',
		}),
		GraphqlModule,
		FeedbackModule,
		AgentModule,
		FaqModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	declarations: [AppComponent],
	bootstrap: [AppComponent],
	providers: [{ provide: ErrorHandler, useClass: GlobalErrorHandler }, provideAppInitializer(loadBrandedPortalKey)],
})
export class AppModule {
	constructor(injector: Injector) {
		ServiceLocator.injector = injector;
		// moment.tz.setDefault(environment.timezone);
		const origin = window.location.origin;
		environment.baseAPIUrl = environment.apiUrls[origin] || environment.baseAPIUrl;
		environment.baseUrl = environment.apiUrls[origin] || environment.baseUrl;
	}
}
